import React, { useEffect, useState } from 'react';
import prettierNumber from 'utils/prettier-number';
import { useClientContext } from '..';
import styles from '../application-group.module.scss';
import ResultBox from '../components/result-box';
import mainTranscript from 'utils/transcript';
import global from 'global';
import request from 'request';
import transcript from 'utils/transcript';

const Main = () => {
	const { group } = useClientContext();
	const [macroData, setMacroData] = useState<global.macrodata>();

	useEffect(() => {
		fetchMacroData();
	}, []);

	const fetchMacroData = async () => {
		try {
			const response = await request.get('/admin/constant_values');
			setMacroData(response.data);
		} catch (error) {
			console.error('Error fetching macrodata:', error);
		}
	};

	const renderGroupInfoItem = (key: string, value: string | number) => (
		<div className={styles.item}>
			<div className={styles.key}>{key}</div>
			<div className={styles.value}>{value}</div>
		</div>
	);

	const application = group?.applications?.[0];
	const scoringLog = application?.scoring_log;

	return (
		<>
			<div className={styles.main}>
				<div className={styles.title}>Group common info</div>
				{macroData && application && (
					<>
						{renderGroupInfoItem('Amount', `${prettierNumber(application.amount)} JOD`)}
						{renderGroupInfoItem('Duration', `${application.duration} mon.`)}
						{renderGroupInfoItem(
							'Interest rate (annual)',
							`${(application.interest_rate * 100).toFixed(2)} %`,
						)}
						{renderGroupInfoItem(
							'Threshold',
							`${((scoringLog?.threshold ?? macroData.threshold) * 100).toFixed()} %`,
						)}
						{renderGroupInfoItem(
							'Branch',
							mainTranscript.branch.getValueFromKey(scoringLog?.branch ?? ''),
						)}
						{renderGroupInfoItem(
							'Prohibited loan purpose',
							scoringLog?.loan_purpose ? 'Yes' : 'No',
						)}
						{renderGroupInfoItem('Active loans', String(application.active_loans_credit_cards))}
						{renderGroupInfoItem(
							'Client residence',
							mainTranscript.city.getValueFromKey(scoringLog?.city ?? ''),
						)}
						{renderGroupInfoItem(
							'Current application with same family ID',
							String(scoringLog?.current_application_with_same_family_id),
						)}
						{renderGroupInfoItem(
							'Repeated client?',
							transcript.clientTypeCode.getValueFromKey(String(application.repeated_client)),
						)}
						{renderGroupInfoItem(
							'Loan duration of current loan',
							String(application.loan_duration_of_current_loan),
						)}
						{renderGroupInfoItem('Prior loans', String(application.prior_loans))}
						{renderGroupInfoItem('Number of payments', String(application.number_of_payments))}
					</>
				)}
			</div>
			<ResultBox />
		</>
	);
};

export default Main;
